import { BASE_URL } from "../screens/Dashboard/CommonApi";
import { getActiveOrganizationHeaderValue } from "./organizationContext";

const buildHeaders = (headers = {}) => {
  const nextHeaders = new Headers(headers);
  const token = localStorage.getItem("jwtToken");
  const organizationId = getActiveOrganizationHeaderValue();

  if (token && !nextHeaders.has("Authorization")) {
    nextHeaders.set("Authorization", `Bearer ${token}`);
  }

  if (organizationId && !nextHeaders.has("X-Organization-Id")) {
    nextHeaders.set("X-Organization-Id", organizationId);
  }

  return nextHeaders;
};

const withActiveOrganizationBody = (body, headers) => {
  const organizationId = getActiveOrganizationHeaderValue();
  if (!organizationId || !body || typeof body !== "object" || Array.isArray(body)) return body;
  if (!(headers.get("Content-Type") || "").includes("application/json")) return body;
  return { ...body, uniqueId: organizationId };
};

export const apiFetch = (endpoint, options = {}) => {
  const url = endpoint.startsWith("http") ? endpoint : `${BASE_URL}${endpoint}`;
  return fetch(url, {
    ...options,
    headers: buildHeaders(options.headers),
  });
};

export const apiPost = (endpoint, body = {}, options = {}) =>
  {
    const headers = buildHeaders({
      "Content-Type": "application/json",
      ...(options.headers || {}),
    });
    return fetch(endpoint.startsWith("http") ? endpoint : `${BASE_URL}${endpoint}`, {
      method: "POST",
      ...options,
      headers,
      body: JSON.stringify(withActiveOrganizationBody(body, headers)),
    });
  };

export const apiPut = (endpoint, body = {}, options = {}) =>
  {
    const headers = buildHeaders({
      "Content-Type": "application/json",
      ...(options.headers || {}),
    });
    return fetch(endpoint.startsWith("http") ? endpoint : `${BASE_URL}${endpoint}`, {
      method: "PUT",
      ...options,
      headers,
      body: JSON.stringify(withActiveOrganizationBody(body, headers)),
    });
  };
